"use client";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import type { ReactNode, ComponentType } from "react";

interface WorkflowStatePanelProps {
  icon: ComponentType<{
    className?: string;
  }>;
  title: string;
  description: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionVariant?: "brand" | "white";
  className?: string;
  iconContainerClassName?: string;
  iconClassName?: string;
}

export function WorkflowStatePanel({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  actionVariant = "brand",
  className,
  iconContainerClassName,
  iconClassName,
}: WorkflowStatePanelProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-16 text-center", className)}>
      <div
        className={cn(
          "bg-ds-neutral-100 dark:bg-ds-neutral-800 mb-4 flex h-16 w-16 items-center justify-center rounded-full",
          iconContainerClassName,
        )}
      >
        <Icon className={cn("text-ds-text-disabled dark:text-ds-text-subtle h-8 w-8", iconClassName)} />
      </div>
      <h3 className="text-ds-text-primary mb-2 text-lg font-semibold">{title}</h3>
      <div className="body-sm mb-6">{description}</div>
      {actionLabel && onAction ? (
        <Button variant={actionVariant} onClick={onAction}>
          <span className="text-xs">{actionLabel}</span>
        </Button>
      ) : null}
    </div>
  );
}
